'use strict';
import { IPC_EVENT } from "./ipc_events";
import BookData from "./js/book_data";
import SaveTool from "./js/toolbar/save_tool";
import RecordHandlerWeb from './data/file/record_handler_web';
import TaskControl from "./js/record_task/task_control";
import { RECORD_TASK_TYPE } from "./data/user_record/record_task_type";
import { useUserStore } from "./js/user_data";
import { API_GET_USER_RECORD } from './js/api';
import { timeFormat } from "./data/time_format";
import { USER_RECORD_BUCKET } from "./js/api/user_record";
import { store } from "./store";
import { RANDOM_CHAR } from "./js/common/random_char";
import ImageControl from './js/record_task/image_control';
import EventBus from './js/event_bus';
import { READ_FILE_AS_DATA_URL } from './js/common/read_file';
import { TOOLS } from "./js/toolbar/tools";
import screenfull from "screenfull";
import { VIEW_TYPE } from "./js/view_type";
import BackgroundWeb from "./background_web";
import { mergeTask } from "./js/record_task/task_store";

export default class BackgroundApp extends BackgroundWeb {
    // app複製插入圖片完成時
    onCopyInsertFinish = null;
    // 存檔資訊(存檔ID、名稱..等)
    recordData = [];
    // 存檔內容(使用者的存檔)
    saveData = null;
    // 是否在檢查重複名稱
    checkNameRepeatInfo = null;
    // 是否正在本機自動存檔
    isAutoSaving = false;
    autoSaveCallback = null;
    constructor() {
        super();
        this.webBackgroundEvent.set(IPC_EVENT.COPY_INSERT_IMAGE_FINISH, this.copyInsertImageFinish.bind(this));
        // 取得存檔列表
        this.webBackgroundEvent.set(IPC_EVENT.SET_USER_RECORD_FROM_APP, this.setUserRecordFromApp.bind(this));
        // 存檔
        this.webBackgroundEvent.set(IPC_EVENT.ADD_USER_RECORD_FINISH, this.addUserRecordFinish.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.UPDATE_USER_RECORD_FINISH, this.updateUserRecordFinish.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.DELETE_USER_RECORD_FINISH, this.deleteUserRecordFinish.bind(this));
        // 同步
        this.webBackgroundEvent.set(IPC_EVENT.ADD_CLOUD_USER_RECORD_TO_LOCAL, this.saveCloudRecord.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.UPDATE_CLOUD_USER_RECORD_TO_LOCAL, this.updateCloudRecord.bind(this));
        // 同步存圖片
        this.webBackgroundEvent.set(IPC_EVENT.SAVE_IMAGE, this.saveImageLocal.bind(this));
        // 插入圖片
        this.webBackgroundEvent.set(IPC_EVENT.MOBILE_IMAGE_OVER_SIZE, this.imgOverSize.bind(this));
        // 本機自動存檔
        this.webBackgroundEvent.set(IPC_EVENT.AUTO_SAVE_LOCAL, this.autoSaveLocal.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.AUTO_SAVE_FINISH, this.autoSaveFinish.bind(this));
        // 離開電子書
        this.webBackgroundEvent.set(IPC_EVENT.BACK_TO_BOOKCASE, this.backToBookCase.bind(this));
        this.webBackgroundEvent.set(IPC_EVENT.EXIT, this.exitApp.bind(this));


        // const userRecord = new UserRecord();
    }

    getPath() {
        //取得並設定書本相關資訊
        // BookData.Instance.setBookPath(`${location.origin}/ebook`);
        const USER_DATA = useUserStore();
        console.log(USER_DATA);

        BookData.Instance.setBookPath(`http://localhost:8080/books/${this.getUrlParam("contentId")}`);
        BookData.Instance.setAppPath(`http://localhost:8080/item`);

        BookData.Instance.loadBookConfig();
        BookData.Instance.loadBookVersion();
        setTimeout(() => {
            window.app.$refs.directory.getDirectoryData();
        }, 1000);
    }

    //#region 存讀檔相關

    async getUserRecord() {
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.getANRecordList(BookData.Instance.BookId);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.getANRecordList.postMessage(BookData.Instance.BookId);
        }
    }

    setUserRecordFromApp(value) {
        let data = value[1], autoSaveData = value[2];

        this.recordData = JSON.parse(data) || [];
        let autoSaveJson = autoSaveData != "" ? JSON.parse(autoSaveData) : null;

        if (this.checkNameRepeatInfo) {
            this.startCheckLogNameRepeat();
        } else {
            SaveTool._instance.showUserRecord(this.recordData, autoSaveJson);
        }
    }

    async loadRecord() {
        let path = arguments[0][1];
        const folderPath = path.substring(0, path.lastIndexOf(".")) + "/";
        const recordName = path.substring(path.lastIndexOf("/") + 1, path.lastIndexOf("."));

        this.startCopyInsertImage(recordName);

        this.onCopyInsertFinish = async () => {
            let response = await fetch(path);
            let data = await response.json();

            if (typeof data == "string") {
                data = JSON.parse(data);
            }

            const fixedData = await this.recordHandlerWeb.adjustRecord(data, folderPath);
            SaveTool._instance.loadUserRecord(JSON.parse(fixedData), path);
        }
    }

    startCopyInsertImage(recordName) {
        // 本機讀檔
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.copyInsertImage(recordName, BookData.Instance.BookId);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            // window.webkit.messageHandlers.copyInsertImage.postMessage(JSON.stringify({
            //     "recordName": recordName,
            //     "bookId": BookData.Instance.BookId
            // }));
        }
    }

    // 複製插入圖片結束(由app呼叫)
    async copyInsertImageFinish() {
        if (this.onCopyInsertFinish) {
            const callback = this.onCopyInsertFinish;
            this.onCopyInsertFinish = null;
            await callback();
        }
    }

    checkLogNameRepeat(value) {
        // 先更新本機紀錄
        this.checkNameRepeatInfo = {
            bookId: value[1],
            userId: value[2],
            logName: value[3]
        }
        this.getUserRecord();
    }

    startCheckLogNameRepeat() {
        //檢查存檔名稱重複事件(此事件只影響是否詢問使用者及本機存檔流程、雲端存檔流程需再次檢查)
        const self = this;
        let bookId = this.checkNameRepeatInfo.bookId;
        let userId = this.checkNameRepeatInfo.userId;
        let logName = this.checkNameRepeatInfo.logName;
        this.checkNameRepeatInfo = null;

        let result = -1;

        // 檢查本機
        for (let i = 0; i < this.recordData.length; i++) {
            const record = this.recordData[i];
            if (record.log_name == logName) {
                console.log("logName: " + logName + "/" + record.id);
                result = {
                    id: record.id,
                    status: record.save_staus
                }
                break;
            }
        }

        // 若要同步則也要檢查雲端
        if (store.mergeToCloud) {
            //檢查雲端重複檔名，若有則替換result結果
            API_GET_USER_RECORD(bookId, userId)
                .then(response => {
                    return response.json();
                }).then(data => {
                    let userRecordOnline = data.content.slice();

                    self.recordTask = {
                        taskName: logName,
                        taskType: RECORD_TASK_TYPE.UPLOAD_TO_CLOUD,
                        updateTime: timeFormat(new Date()),
                        url: `http://localhost:8080/userRecord/${bookId}/${logName}.json`
                    };

                    for (let i = 0; i < userRecordOnline.length; i++) {
                        if (userRecordOnline[i].log_name == logName) {
                            self.recordTask.log_id = userRecordOnline[i].log_id;
                            self.recordTask.taskType = RECORD_TASK_TYPE.UPDATE_TO_CLOUD;

                            result = {
                                id: result == -1 ? null : result.id,
                                status: result == -1 ? userRecordOnline[i].save_staus : result.status
                            }
                            break;
                        }
                    }

                    //確認覆蓋視窗
                    SaveTool._instance.handleNameRepeatCheck(result);
                });
        } else {
            SaveTool._instance.handleNameRepeatCheck(result);
        }
    }

    // 新增存檔
    addUserRecord() {
        // 本機存檔
        let bookId = arguments[0][1], userId = arguments[0][2], logName = arguments[0][3], data = arguments[0][4];
        this.saveData = data;

        let recordData = {
            log_name: logName,
            book_id: bookId,
            user_id: userId,
            update_time: null
        }
        this.startAddUserRecord(recordData, data);
    }

    startAddUserRecord(recordData, saveData, isMerge = false) {
        //本機儲存
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.saveANRecord(JSON.stringify(recordData), saveData, `${isMerge}`);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.saveANRecord.postMessage(JSON.stringify({
                "recordData": recordData,
                "saveData": saveData,
                "isMerge": isMerge
            }));
        }
    }

    // 新增存檔結束(由app呼叫)
    async addUserRecordFinish(value) {
        let result = {
            success: value[1] == "success"
        }
        if (result.success == true && store.mergeToCloud) {
            // 雲端儲存
            result = await TaskControl.Instance.uploadTask(this.recordTask, this.saveData);

            if (result.success) {
                SaveTool._instance.showFinish(result);
            }
        } else {
            SaveTool._instance.showFinish(result);
        }
    }

    updateUserRecord() {
        //覆蓋檔案
        let logId = arguments[0][1], data = arguments[0][2];
        this.saveData = data;

        let recordData = {
            id: logId,
            update_time: null
        }

        this.startUpdateUserRecord(recordData, data)
    }

    startUpdateUserRecord(recordData, saveData, isMerge = false) {
        //本機儲存
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.updateANRecord(JSON.stringify(recordData), saveData, `${isMerge}`);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.updateANRecord.postMessage(JSON.stringify({
                "recordData": recordData,
                "saveData": saveData,
                "isMerge": isMerge
            }));
        }
    }

    // 更新存檔結束(由app呼叫)
    async updateUserRecordFinish(value) {
        let result = {
            success: value[1] == "success"
        }
        if (result.success == true && store.mergeToCloud) {
            // 雲端儲存
            result = await TaskControl.Instance.uploadTask(this.recordTask, this.saveData);

            if (result.success) {
                SaveTool._instance.showFinish(result);
            }
        } else {
            SaveTool._instance.showFinish(result);
        }
    }

    deleteUserRecord() {
        // 刪除檔案(本機)
        let recordId = arguments[0][1], recordName = arguments[0][2], recordFilePath = arguments[0][3];

        //本機儲存
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.deleteANRecord(recordId);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.deleteANRecord.postMessage(recordId);
        }
    }

    // 刪除存檔結束(由app呼叫)
    deleteUserRecordFinish() {
        this.getUserRecord();
    }

    // 將雲端存檔存到本地(新增)
    saveCloudRecord() {
        let bookId = arguments[0][1], userId = arguments[0][2], logName = arguments[0][3], updateTime = arguments[0][4], data = arguments[0][5];
        let recordData = {
            log_name: logName,
            book_id: bookId,
            user_id: userId,
            update_time: updateTime
        }
        this.startAddUserRecord(recordData, data);
    }

    // 將雲端存檔存到本地(更新)
    updateCloudRecord() {
        let logId = arguments[0][1], updateTime = arguments[0][2], data = arguments[0][3];
        let recordData = {
            id: logId,
            update_time: updateTime
        }
        this.startUpdateUserRecord(recordData, data)
    }

    mergeCloudDataFinish(value) {
        let result = value[1];
        let logName = value[2];
        if (result = "success") {
            mergeTask.setTaskResult(logName, "success");
        } else {
            mergeTask.setTaskResult(logName, "fail");
        }
    }

    // 自動存檔
    autoSaveLocal(value) {
        console.log("autoSaveLocal")
        let bookId = value[1], saveData = value[2];
        this.isAutoSaving = true;

        //本機儲存
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.autoSaveANRecord(bookId, saveData);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.autoSaveANRecord.postMessage(JSON.stringify({
                "bookId": bookId,
                "saveData": saveData
            }));
        }
    }

    autoSaveFinish() {
        this.isAutoSaving = false;
        if (this.autoSaveCallback) {
            this.autoSaveCallback();
            this.autoSaveCallback = null;
        }
    }

    //#endregion

    //#region 插入圖片相關

    async handleInsertImage(values) {
        const imageName = values[1], dataUrl = values[2];
        EventBus.getInstance().getAppRefs().insertPicture.setImage(dataUrl, imageName);
        ImageControl.Instance.addImage(imageName);
    }

    imgOverSize() {
        EventBus.getInstance().getAppRefs().insertPicture.imgOverSize();
    }

    // 地端存圖片
    saveImageLocal(value) {
        let bookId = value[1], recordName = value[2], imageName = value[3], data = value[4];
        let binary = '';
        for (let i = 0; i < data.byteLength; i++) {
            binary += String.fromCharCode(data[i]);
        }
        let b64encoded = window.btoa(binary);

        //本機儲存
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.saveImageLocal(bookId, recordName, imageName, b64encoded);
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.saveImageLocal.postMessage(JSON.stringify({
                "bookId": bookId,
                "recordName": recordName,
                "imageName": imageName,
                "data": b64encoded
            }));
        }
    }

    //#endregion

    // 回到書櫃
    backToBookCase() {
        console.log("backToBookCase")
        if (this.isAutoSaving) {
            this.autoSaveCallback = this.backToBookCase;
            return;
        }
        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            document.location.href = "file:///android_asset/index.html"
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            document.location.href = "http://localhost:8080/index.html";
        }
    }

    exitApp() {
        console.log("exitApp")
        if (this.isAutoSaving) {
            this.autoSaveCallback = this.exitApp;
            return;
        }
        console.log(`關閉APP`);

        if (store.nowView == VIEW_TYPE.ANDROID) {
            // android
            JSInterface.exitApp();
        } else if (store.nowView == VIEW_TYPE.IOS) {
            // ios
            window.webkit.messageHandlers.exitApp.postMessage("");
        }
    }
}